import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const SouthIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M 1 5 C 1 2.792969 2.789062 1 5 1 C 7.210938 1 9 2.792969 9 5 C 9 7.210938 7.210938 9 5 9 C 2.789062 9 1 7.210938 1 5 Z M 1 5" />
            <path
                d="M 1.753906 7.335938 C 1.320312 6.738281 1.066406 6.03125 1.011719 5.292969 C 0.957031 4.558594 1.105469 3.820312 1.445312 3.164062 C 1.785156 2.511719 2.296875 1.960938 2.929688 1.578125 C 3.558594 1.195312 4.285156 0.996094 5.023438 1 C 5.761719 1.003906 6.484375 1.210938 7.109375 1.601562 C 7.738281 1.992188 8.242188 2.546875 8.574219 3.207031 C 8.90625 3.867188 9.046875 4.605469 8.984375 5.339844 C 8.921875 6.074219 8.660156 6.777344 8.222656 7.371094 L 5 5 Z M 1.753906 7.335938"
                fill="#ededee"
            />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const SouthIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M 1 5 C 1 2.792969 2.789062 1 5 1 C 7.210938 1 9 2.792969 9 5 C 9 7.210938 7.210938 9 5 9 C 2.789062 9 1 7.210938 1 5 Z M 1 5" />
            <path
                d="M 1.753906 7.335938 C 1.320312 6.738281 1.066406 6.03125 1.011719 5.292969 C 0.957031 4.558594 1.105469 3.820312 1.445312 3.164062 C 1.785156 2.511719 2.296875 1.960938 2.929688 1.578125 C 3.558594 1.195312 4.285156 0.996094 5.023438 1 C 5.761719 1.003906 6.484375 1.210938 7.109375 1.601562 C 7.738281 1.992188 8.242188 2.546875 8.574219 3.207031 C 8.90625 3.867188 9.046875 4.605469 8.984375 5.339844 C 8.921875 6.074219 8.660156 6.777344 8.222656 7.371094 L 5 5 Z M 1.753906 7.335938"
                fill="#ededee"
            />
        </SvgIcon>
    );
};
